import { ModelBase } from "@models/UpsertableBase";
import { DataType } from "@dndModels/Types";

/**
 * A kind of place an encounter can take place in: Cave, Underwater, Ship Deck, Frozen Lake, Laboratory, etc.
 * An encounter can have several (an underwater cave is Underwater and Cave).
 *
 * Environments don't hold their links to other things.
 * Complications and Creatures point at Environments instead (via environment_ids),
 * so homebrew can attach itself to official Environments without editing them.
 */
export class Environment extends ModelBase {
  data_type: DataType = "environment";

  constructor(obj?: any) {
    super(obj);
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
    };
  }

  copy(copyMe: Environment, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
  }

  clone(drop_ids = false): Environment {
    const new_obj = new Environment();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}
